/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { PageGridContainer } from '@coursera/cds-core';

import TrackedDiv from 'bundles/page/components/TrackedDiv';
import LazyImgix from 'bundles/page/components/shared/LazyImgix';
import CertificateAndBenefitsText from 'bundles/unified-description-page-common/components/shared/CertificateAndBenefitsText';
import Section from 'bundles/unified-description-page-common/components/shared/Section';

import CareerCertificateImage from 'images/unified-description-page/career-certificate.png';

import _t from 'i18n!nls/xdp';

type Props = {
  title: string;
  description: React.ReactNode;
};

const styles = {
  imageContainerDesktop: css`
    position: absolute;
    right: 43px;
    top: 50%;
    transform: translateY(-50%);
    height: 215px;
    width: 333px;
    box-shadow: 0 4px 20px rgb(0 0 0 / 20%);

    @media (max-width: 1150px) {
      right: 50%;
      transform: translate(50%, -50%);
    }
  `,

  mobileCertImage: css`
    box-shadow: 0 4px 20px rgb(0 0 0 / 10%);
    height: 165px;
    width: 259px;
  `,
};

const CareerCertificateModule = ({ title, description }: Props) => {
  return (
    <TrackedDiv
      trackingName="career_cert_module"
      trackClicks={false}
      requireFullyVisible={false}
      withVisibilityTracking={true}
    >
      <Section>
        <PageGridContainer>
          <CertificateAndBenefitsText
            title={title}
            description={description}
            mobileImage={
              <LazyImgix
                src={CareerCertificateImage}
                alt={_t('Coursera Career Certificate')}
                maxWidth={259}
                maxHeight={165}
                css={styles.mobileCertImage}
              />
            }
            desktopImage={
              <div css={styles.imageContainerDesktop}>
                <LazyImgix
                  src={CareerCertificateImage}
                  alt={_t('Coursera Career Certificate')}
                  maxWidth={333}
                  maxHeight={215}
                />
              </div>
            }
          />
        </PageGridContainer>
      </Section>
    </TrackedDiv>
  );
};

export default CareerCertificateModule;
